<template>
  <div class="wizard-triage">
    <h3>
      {{ triage.contact_wizard_triage_question_insurance_type }}
    </h3>
    <radio-group
      v-model="result.insurance"
      required
      horizontal
      :items="insurances"
    />
    <template v-if="displayCompact(result.insurance)">
      <h3>
        {{ triage.contact_wizard_triage_question_is_compact }}
      </h3>
      <radio-group
        v-model="result.compact"
        required
        horizontal
        :items="compact"
      />
    </template>
  </div>
</template>

<script>
export default {
  name: 'WizardTriageFull',
  components: {
    RadioGroup: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/RadioGroup'
      )
    },
  },
  props: {
    triage: {
      type: Object,
      default: () => ({}),
    },
    showNotCustomer: Boolean,
  },
  data: () => ({
    result: {},
  }),
  computed: {
    insurances() {
      const { triage, showNotCustomer } = this
      const result = [
        {
          text: triage.contact_wizard_triage_general_title,
          value: 'general',
        },
        {
          text: triage.contact_wizard_triage_private_title,
          value: 'private',
        },
      ]
      if (showNotCustomer) {
        result.push({
          text: triage.contact_wizard_triage_not_customer_title,
          value: 'not_customer',
        })
      }
      return result
    },
    compact() {
      return [
        {
          text: this.triage.contact_wizard_triage_is_compact,
          value: 'yes',
        },
        {
          text: this.triage.contact_wizard_triage_is_not_compact,
          value: 'no',
        },
      ]
    },
  },
  watch: {
    result: {
      handler(result) {
        let content = ''
        const { triage } = this
        if (
          result.insurance &&
          (result.compact || result.insurance !== 'general')
        ) {
          if (result.insurance === 'not_customer') {
            content = triage.contact_wizard_triage_not_customer_path
          } else if (result.insurance === 'private') {
            content = triage.contact_wizard_triage_private_path
          } else {
            if (result.compact === 'yes') {
              content = triage.contact_wizard_triage_compact_path
            } else {
              content = triage.contact_wizard_triage_not_compact_path
            }
          }
          this.$emit('wizardTriageCompleted', content)
        }
      },
      deep: true,
    },
  },

  methods: {
    displayCompact(insurance) {
      return insurance === 'general'
    },
  },
}
</script>
